import { render, staticRenderFns } from "./ValidatableTextInput.vue?vue&type=template&id=23be98d3&"
import script from "./ValidatableTextInput.vue?vue&type=script&lang=js&"
export * from "./ValidatableTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports